import { useLanguage } from "../lib/LanguageContext";
import { CONTACT } from "../lib/translations";

export default function Footer() {
  const { lang, t } = useLanguage();
  const schedule = CONTACT.schedule[lang];

  return (
    <footer data-testid="site-footer" className="bg-cream-200 text-ink py-20 border-t border-dustyrose/40">
      <div className="max-w-[1480px] mx-auto px-6 md:px-12 lg:px-20 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="inline-flex items-center text-ink" data-testid="footer-brand">
            <img src="/logo-amaranto.svg" alt="Amaranto" className="h-14 w-auto" />
            <span className="sr-only">Amaranto</span>
          </div>
          <p className="mt-6 font-serif italic text-2xl text-ink-soft leading-snug max-w-xs">{t.footer.tagline}</p>
          <div className="mt-3 inline-flex items-center gap-3">
            <span className="block w-10 h-px bg-dustyrose" aria-hidden />
            <span className="eyebrow !text-warmbrown text-[10px]">CDMX</span>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="eyebrow mb-5">{t.footer.links.kits}</p>
          <ul className="font-body text-sm space-y-3 text-ink-soft">
            <li><a href="#kits" className="hover:text-dustyrose-deep transition-colors" data-testid="footer-link-kits">{t.nav.kits}</a></li>
            <li><a href="#hero-product" className="hover:text-dustyrose-deep transition-colors" data-testid="footer-link-hero">{t.nav.hero}</a></li>
            <li><a href="#craft" className="hover:text-dustyrose-deep transition-colors" data-testid="footer-link-craft">{t.nav.craft}</a></li>
            <li><a href="#corporate" className="hover:text-dustyrose-deep transition-colors" data-testid="footer-link-corporate">{t.nav.corporate}</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="eyebrow mb-5">{t.footer.links.contact}</p>
          <ul className="font-body text-sm space-y-3 text-ink-soft">
            <li>
              <a
                href={`https://wa.me/${CONTACT.whatsappNumber}`}
                target="_blank"
                rel="noreferrer"
                className="hover:text-dustyrose-deep transition-colors"
                data-testid="footer-whatsapp"
              >
                WhatsApp · {CONTACT.whatsappDisplay}
              </a>
            </li>
            <li>
              <a
                href={`https://instagram.com/${CONTACT.instagramHandle}`}
                target="_blank"
                rel="noreferrer"
                className="hover:text-dustyrose-deep transition-colors"
                data-testid="footer-instagram"
              >
                Instagram · @{CONTACT.instagramHandle}
              </a>
            </li>
            <li className="pt-2 text-ink-soft/80">{t.footer.city}</li>
          </ul>

          {/* Schedule block */}
          <div className="mt-8 pt-6 border-t border-dustyrose/40" data-testid="footer-schedule">
            <p className="eyebrow !text-warmbrown mb-3">{schedule.title}</p>
            <ul className="font-body text-sm space-y-1.5 text-ink-soft leading-relaxed">
              {schedule.lines.map((line, i) => (
                <li key={i}>{line}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="max-w-[1480px] mx-auto px-6 md:px-12 lg:px-20 mt-16 pt-8 border-t border-cream-300 flex flex-col md:flex-row gap-3 justify-between text-xs tracking-[0.22em] uppercase text-ink-soft">
        <span>© {new Date().getFullYear()} Amaranto · {t.footer.rights}</span>
        <span className="font-body italic normal-case tracking-normal">Hecho con calma en CDMX.</span>
      </div>
    </footer>
  );
}
